import { apiFetch, apiRequest, ApiResult } from './api';

export type UserRole = 'Admin' | 'Manager' | 'Sales' | 'WhiteLabel';

export interface User {
  id: string;
  name: string;
  username: string;
  phone: string;
  role: UserRole | string;
  managerUserId?: string | null;
  active: boolean;
  shouldResetPassword: boolean;
  segmentId?: string | null;
}

export interface UserRQ {
  name: string;
  username: string;
  phone: string;
  role: UserRole;
  managerUserId?: string | null;
  active: boolean;
  shouldResetPassword: boolean;
  password?: string;
  segmentId?: string | null;
}

export interface UserUpdateRQ {
  name: string;
  phone: string;
  role: UserRole;
  managerUserId?: string | null;
  active: boolean;
  shouldResetPassword: boolean;
  password?: string;
  segmentId?: string | null;
}

export const userApi = {
  async getManagers(): Promise<Array<Pick<User, 'id' | 'name' | 'username' | 'role'>>> {
    return apiFetch<Array<Pick<User, 'id' | 'name' | 'username' | 'role'>>>('/User/GetManagers', { auth: true });
  },
  async list(): Promise<User[]> {
    return apiFetch<User[]>('/UserCrud/GetAll', { auth: true });
  },
  async get(id: string): Promise<User> {
    return apiFetch<User>(`/UserCrud/Get/${encodeURIComponent(id)}`, { auth: true });
  },
  async create(data: UserRQ): Promise<ApiResult<User>> {
    return apiRequest<User>('/UserCrud/Create', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(data),
    });
  },
  async update(id: string, data: UserUpdateRQ): Promise<ApiResult<User>> {
    return apiRequest<User>(`/UserCrud/UpdateUser/${encodeURIComponent(id)}`, {
      method: 'PUT',
      auth: true,
      body: JSON.stringify(data),
    });
  },
  async activate(id: string): Promise<void> {
    return apiFetch<void>(`/UserCrud/Active/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      auth: true,
    });
  },
  async deactivate(id: string): Promise<void> {
    return apiFetch<void>(`/UserCrud/Inactive/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      auth: true,
    });
  },
  async remove(id: string): Promise<void> {
    return apiFetch<void>(`/UserCrud/Delete/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      auth: true,
    });
  },
};


